import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import TrackChangesComponent from './TrackChangesComponent';
import {formBodyType} from '../../../util/uiconstants';

function TrackChangesContainer({formBody, headerId, children}) {
	const snapshotCompareDetails = useSelector((store) => store.snapshotCompareDetails);
	const [currentBodyData, setCurrentBodyData] = useState(null);

	const getClassName = (bodyId) => {
		return Object.keys(formBodyType)?.find((id) => formBodyType[id] === bodyId) + 'Container';
	};

	useEffect(() => {
		if (snapshotCompareDetails?.length > 0) {
			const data = snapshotCompareDetails && snapshotCompareDetails?.find((c) => c.id === headerId)?.sections;
			const bodies = data && data.find((x) => x.id === formBody.sectionId)?.bodies;
			setCurrentBodyData(bodies && bodies.find((x) => x.id === formBody.id));
		}
	}, [snapshotCompareDetails]);

	return (
		<>
			{currentBodyData ? (
				<StyledTrackChangesContainer
					className={`StyledTrackChangesContainer ${getClassName(currentBodyData.bodyTypeId)}`}
				>
					<section
						className={`form-body ${
							currentBodyData.isAdded || currentBodyData.isChanged ? 'formBodyTrackChanges' : ''
						}`}
					>
						{children}
					</section>
					{(currentBodyData.isAdded || currentBodyData.isChanged) && (
						<section className="changes">
							<TrackChangesComponent changes={currentBodyData} />
						</section>
					)}
				</StyledTrackChangesContainer>
			) : (
				<>{children}</>
			)}
		</>
	);
}

export default TrackChangesContainer;

const StyledTrackChangesContainer = styled.section`
	.form-body {
		&.formBodyTrackChanges {
			.SectionBodyWrapper {
				.SectionBodyData {
					border-bottom: 0 !important;
				}
			}
		}
		.SectionBodyWrapper {
			.DropDownListBodyData {
				background-color: var(--neutrals-00white);
				border: var(--px-1) solid var(--neutrals-200);
				border-bottom: 0;
				padding: var(--px-24);
				border-radius: var(--px-12) var(--px-12) 0 0;
				width: 100%;
			}
			.SectionBodyDescription_RadioButtonHorizontal {
				.SectionBodyDescriptionRow {
					.SectionBodyDescriptionWrapper {
						width: calc(100% - var(--px-250)) !important;
					}
				}
			}
		}
	}
	.changes {
		background-color: var(--neutrals-00white);
		border: var(--px-1) solid var(--neutrals-200);
		border-top: 0;
		padding: var(--px-10);
		border-radius: 0 0 var(--px-12) var(--px-12);
	}

	&.SliderContainer,
	&.SliderLegendContainer {
		.changes {
			border: 0;
		}
	}
`;
